



























































































































































import {
    Component,
    Vue,
    Watch
} from 'vue-property-decorator';


import axios from '../common/api';
import {
    aggre
} from '../common/utils';
import dayjs from 'dayjs';
import { values } from '../common/domain';
import DeliverPicker from '../components/DeliverPicker.vue'
import { EDU_BG_MAP } from '../common/const';

let loading = null

const  createOrder = ()=>{
    return {
        type : -1,
        product_name :'',
        specid: 0,
        is_urgent: -1,
        deliver_date: '',
        purpose_link: '',
        remark: '',
        price: 0,
        words: '',
        email: '',
        client_name: '',
        upload_deadline : '',
        edu_bg : localStorage.getItem('edubg') ? localStorage.getItem('edubg') : ''
    }
} 

@Component({
    components: {
        DeliverPicker
    },
})
export default class Index extends Vue {

    products: any[] = []



    specs:any[] = []

    specMap:any = {}

    spec: number = 1

    prices: any[] = []

    orders:any[] = []

    schedules:any[] = []

    order = createOrder()

    workingDays:number = 0

    EDU_BG_MAP = EDU_BG_MAP

    hasUnknownPrice: boolean = false
  


    pickerOptions={}



   
    @Watch('user',{immediate:true})
    onUserChange(user){
        if(user){

            this.order.email = user.email
        }
    }

    @Watch('order.is_urgent',{immediate:true})
    onUrgentChange(val){
        if(val === 1){
            this.order.deliver_date = ''
        }
    }

    @Watch('order.specid')
    onSpecChange(){
        console.log('spec id changed')
        this.order.deliver_date = ''
    }
   
   
    get prods() {
        let res = this.specs.filter(p => p.spec_type === this.order.type)
        res = aggre(res, 'product_name')
        return res
    }

    get words() {
        let res = this.specs.filter(p => p.product_name === this.order.product_name)
        res = aggre(res,'words')
        console.log('words res',res)
        this.order.words = res[0]
        return res
    }
  

    get totalPrice(){
        let price = 0
        let hasUnknownPrice  = false
        let orders = [...this.orders, this.order]
        for(let order of orders){
            let p = this.specs.find(p=>p.words == order.words &&  p.spec_type === order.type && p.product_name == order.product_name)
            // 其他商品，没有价格，走紧急流程
            if(p && !p.price || order.is_urgent === 1){
                hasUnknownPrice = true
                order.price = null
            } else if(p){
                order.price = p.price
                price += p.price
            }
            if(p){
                order.specid = p.id
                let workingDays = Number(p.period.split('-').pop())
                if(workingDays){
                    workingDays -= 1
                }
                this.workingDays = workingDays

            }
        }
        this.hasUnknownPrice = hasUnknownPrice
        if(hasUnknownPrice){
            return '待确认'
        }
        return price
    }
    get user(){
        return this.$store.state.user
    }

    get deliver_note(){
        if(this.order.specid && this.order.deliver_date){
            let spec = this.specMap[this.order.specid]
            console.log(spec, this.order.deliver_date)
            let leastDays = Number(spec.period.split('-')[0])
            let lastday = dayjs(this.order.deliver_date).subtract(leastDays,'day')
            return lastday.format('YYYY-MM-DD')
        }
        return ''
    }
    created() {
        // let day = dayjs().add(6,'day').format('YYYY-MM-DD')
        // this.order.deliver_date = day

        axios.get('/specs').then(res => {
            console.log(res.data)
            this.specs = res.data
            let specMap:any = {}
            res.data.forEach(s=>{
                specMap[s.id] = s
            })
            this.specMap = specMap
        })
        axios.get('/products').then(res=>{
            this.products = res.data
        })
        axios.get('/specschedules').then(res=>{
            this.schedules = res.data
        })
        axios.get('/cart').then(res=>{
            this.orders = res.data
        })
        let self = this
        
    }
    dateChange(val){
        this.order.deliver_date = dayjs(val).format('YYYY-MM-DD')
    }
    checkInput(){
          let {
            product_name,
            specid,
            is_urgent,
            deliver_date,
            purpose_link,
            remark,
            price,
            email,
            client_name,
            edu_bg
        } = this.order
        this.order.upload_deadline = this.deliver_note
        if(!specid ||!purpose_link || !client_name || !edu_bg ){
            alert('订单信息还不完善哦')
            return false
        }
        if(!is_urgent && !deliver_date){
            alert('非加急创作的订单请选择预期交付时间')
            return false
        }
        // if(!this.order.deliver_date){
        //     this.order.deliver_date = dayjs().add(6,'day').format('YYYY-MM-DD')
        // }
        return true
    }
    submit() {
        if(!this.checkInput()){
            return
        }
        let orders = [
            ...this.orders,
            this.order
        ]
        // this.orders.push(this.order)
        Promise.all(orders.map(o=>{
            delete o.id
            return axios.post('/submitorder',o).then(res=>res.data)
        })).then(res=>{
            if(this.totalPrice === '待确认'){
                this.$router.replace('/holdon')
            } else {
                let ids = []
                res.forEach(o=>{
                    ids.push(...o)
                })
                values.payingOrderIds = ids

                this.$router.replace('/pay/'+this.totalPrice)
            }
        })

        localStorage.setItem('edubg', this.order.edu_bg.toString())
        

    }
    async addMore() {
        if(!this.checkInput()){
            return
        }
        await axios.post('/cart', this.order)
        localStorage.setItem('edubg', this.order.edu_bg.toString())

        this.orders.push(this.order)
        window.scrollTo(0,0)
        this.order = createOrder()
        this.order.email = this.user.email
    }
    async del(index){
        let item = this.orders[index]
        await axios.delete('/cart?id='+item.id)
        this.orders.splice(index,1)
    }
}
